import React, { useState } from 'react';
import { Grid } from '@mui/material';
import Header from '../../Header/Header';
import AcademicYearSelector from '../../Common/AcademicYearSelector';
import CustomerSelector from '../../Common/CustomerSelector';
import SiteSelector from '../../Common/SiteSelector';
import { AcademicYearDTO, CustomerDTO, SiteDTO } from '@beable/roster-backend-client-v1';
import CourseAccordion from './CourseAccordion';
import BasePanel from '../../Common/Layout/BasePanel';
import { BasePanelBox } from '../../Common/Layout/BasePanelBox';
import BaseSheet from '../../Common/Layout/BaseSheet';
import { StyledPanelHeader } from '../../Common/Layout/PanelHeader';
import CourseViewSelector from './CourseViewSelector';
import CourseDashboard from './CourseDashboard';
import CloneSchedule from './CloneSchedule';

export default function CourseSchedule() {
  const [customer, setCustomer] = useState<CustomerDTO>();
  const [site, setSite] = useState<SiteDTO>();
  const [academicYear, setAcademicYear] = useState<AcademicYearDTO>();
  const [viewType, setViewType] = useState('');

  const handleCustomerChange = (customer: CustomerDTO | undefined) => {
    resetSelections();
    setCustomer(customer);
  }

  const handleSiteChange = (site: SiteDTO | undefined) => {
    resetSelections();
    setSite(site);
  }

  const resetSelections = () => {
    setSite(undefined);
    setAcademicYear(undefined);
  }

  const getView = () => {
    if (!customer || !site || !academicYear || !viewType)
      return;

    switch (viewType) {
      case "schedule":
        return (
          <CourseAccordion
            customer={customer}
            site={site}
            academicYearId={academicYear.academicYearId}
          />
        )
      case "clone":
        return (
          <CloneSchedule
            customer={customer}
            site={site}
            academicYear={academicYear}
          />
        )
      default: 
        return (
          <CourseDashboard
            customer={customer}
            site={site}
            academicYearId={academicYear.academicYearId}
          />
        )
    }
  }

  return (
    <>
      <Header />
      <Grid container>
        <BasePanel>
          <BasePanelBox>
            <StyledPanelHeader header="View Course Schedule" />
            <Grid container size={12}>
              <CustomerSelector
                onSelect={handleCustomerChange}
              />
              <SiteSelector
                customerId={customer ? customer.id : ''}
                onSelect={handleSiteChange}
                disabled={!customer}
              />
              <AcademicYearSelector
                siteId={site ? site.id : 0}
                handleSelection={(academicYear: AcademicYearDTO | undefined) => setAcademicYear(academicYear)}
                disabled={!site}
                includePrevious
              />
              <CourseViewSelector
                siteId={site ? site.id : 0}
                onChange={(viewType: string) => setViewType(viewType)}
              />
            </Grid>
          </BasePanelBox>
        </BasePanel>
        <BaseSheet maxWidth='lg'>
          <Grid size={12}>
            {getView()}
          </Grid>
        </BaseSheet>
      </Grid >
    </>
  );
}
